import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ErrorBoundary from "./pages/Errorboundry";
import { BrowserRouter } from "react-router-dom";
import { register } from "./serviceWorkerRegistration"; // Import the register function
import { Provider } from "react-redux";
import "./App.css";
import "./index.css";
import "./custom-theme.less";
import { registerLicense } from "@syncfusion/ej2-base";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./app/store";



const root = ReactDOM.createRoot(document.getElementById("root"));

const registerLicenseKey =
"Ngo9BigBOggjHTQxAR8/V1NBaF5cXmZCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWXdcd3VUR2ZdWUB+XEo=";
registerLicense(registerLicenseKey);

register({
  onSuccess: (registration) => {
    console.log("Service worker registration successful:", registration);
  },
  onUpdate: (registration) => {
    console.log("Service worker update detected:", registration);
    if (window.confirm("A new version is available. Do you want to refresh?")) {
      window.location.reload();
    }
  },
});

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/firebase-messaging-sw.js')
    .then(function(registration) {
      console.log('Service Worker registered with scope:', registration.scope);
    })
    .catch(function(error) {
      console.error('Service Worker registration failed:', error);
    });
}

root.render(

  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
    <ErrorBoundary>
      <BrowserRouter>
      <App className="scroll-smooth bg-violet-100" />
      </BrowserRouter>
    </ErrorBoundary>
    </PersistGate>
  </Provider>,

  // <Provider store={store}>
  //       <App className="scroll-smooth" />
  // </Provider>
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// serviceWorker.register();
